import { useEffect, useState } from "react";

const KEY = "fk_splash_seen";

export default function LoadingSplash() {
  const [visible, setVisible] = useState(() => {
    if (typeof window === "undefined") return false;
    return !sessionStorage.getItem(KEY);
  });
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    if (!visible) return;
    const t1 = setTimeout(() => setFadeOut(true), 1100);
    const t2 = setTimeout(() => {
      setVisible(false);
      sessionStorage.setItem(KEY, "1");
    }, 1700);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      data-testid="loading-splash"
      className={`fixed inset-0 z-[100] bg-[#0A0A0C] flex items-center justify-center transition-opacity duration-600 ${
        fadeOut ? "opacity-0 pointer-events-none" : "opacity-100"
      }`}
    >
      <div className="flex flex-col items-center gap-6">
        <div className="splash-mark w-16 h-16 border border-white/40 flex items-center justify-center font-display font-semibold text-2xl tracking-tighter text-white">
          FK
        </div>
        <div className="overflow-hidden h-px w-32 bg-white/10">
          <div className="h-full w-full bg-white splash-line" />
        </div>
        <div className="text-[10px] uppercase tracking-[0.32em] text-zinc-500 splash-name">
          Fritz Kamm AG
        </div>
      </div>
    </div>
  );
}
